WYATT.registerComponent(
  "store-menu",
  class StoreMenu extends HTMLElement {
    connectedCallback() {
      const store = WYATT.selectedStore();
      const address = this.querySelector("[data-store-menu-address]");

      address.textContent = store.address;
      address.setAttribute("href", store.map_link);

      this.querySelector("[data-store-menu-name]").textContent = store.name;
      this.querySelector("[data-store-menu-phone]").textContent = store.phone;
      this.querySelector("[data-store-menu-hours]").innerHTML = store.hours;
    }
  }
);
